jQuery(function($) {
  // Initialise Foundation
  $(document).foundation();

  // -----------------------------------------------------------------------
  // Scroll Reveal
  // -----------------------------------------------------------------------
  // ScrollReveal().reveal('.headingType', {
  //   delay: 250,
  //   distance: '200px',
  //   duration: 1500,
  //   once: true,
  // });

  // ScrollReveal().reveal('.contentType', {
  //   delay: 1000,
  //   distance: '250px',
  //   duration: 2000,
  //   once: true,
  // });

  // ScrollReveal().reveal('.buttonType', {
  //   delay: 1500,
  //   distance: '250px',
  //   duration: 2000,
  //   once: true,
  // });

  // ScrollReveal().reveal('.scrollType', {
  //   delay: 2000,
  //   distance: '250px',
  //   duration: 3000,
  //   once: false,
  // });

  // -----------------------------------------------------------------------
  // Header and Scroll functionality
  // -----------------------------------------------------------------------

  $(document).ready(function() {
    var $header = $('.desktop-header');
    var $subMenu = $('.sub-menu');
    var hideMenuTimeout;

    if (!$header.length) return;

    // Function to toggle 'scrolled' class based on scroll position
    function toggleScrolledClass() {
      if ($(document).scrollTop() > 25) {
        $header.addClass('scrolled');
      } else {
        $header.removeClass('scrolled');
      }
    }

    // Run function on scroll and page load
    toggleScrolledClass();
    $(document).on('scroll', toggleScrolledClass);

    $('.has-mega-menu').mouseenter(function() {
      clearTimeout(hideMenuTimeout);
      requestAnimationFrame(() => {
        $header.addClass('menu-active');
        $('.mega-menu').hide();
        let index = $(this).index('.has-mega-menu');
        $('.mega-menu')
          .eq(index)
          .show();
        $subMenu.show();
      });
    });

    $subMenu.mouseenter(function() {
      clearTimeout(hideMenuTimeout);
      $header.addClass('menu-active');
    });

    $('.desktop-header, .sub-menu').mouseleave(function() {
      hideMenuTimeout = setTimeout(() => {
        $subMenu.hide();
        $('.mega-menu').hide();
        if ($(window).scrollTop() <= 25) {
          $header.removeClass('menu-active');
        }
      }, 100);
    });

    $('.desktop-header__navigation li:not(.has-mega-menu)').mouseenter(function() {
      clearTimeout(hideMenuTimeout);
      $subMenu.hide();
      $('.mega-menu').hide();
      if ($(window).scrollTop() <= 25) {
        $header.removeClass('menu-active');
      }
    });

    function setSubMenuMaxHeight() {
      var headerH = $('.desktop-header').outerHeight() || 0;
      $('.sub-menu__links').css('max-height', `calc(100vh - ${headerH + 20}px)`);
    }

    $(window).on('resize', setSubMenuMaxHeight);
    setSubMenuMaxHeight();

    $('.has-mega-menu').mouseenter(function() {
      setSubMenuMaxHeight();
    });
  });

  // Mobile Navigation
  // --------------------------------------------------
  $(document).ready(function() {
    // Open / close mobile nav
    $('#menuToggle').on('click', function() {
      $('#mobileNav').addClass('active');
    });

    $('#menuClose').on('click', function() {
      $('#mobileNav').removeClass('active');
    });

    $('.menu').on('click', '.menu__arrow', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const $arrow = $(this);
      const $li = $arrow.closest('li');
      const $submenu = $li.children('ul');

      if (!$submenu.length) return;

      if ($submenu.is(':visible')) {
        $submenu.slideUp(300);
        $arrow.removeClass('active');
      } else {
        $li
          .siblings('.menu__item--has-submenu')
          .children('ul')
          .slideUp(300);

        $li
          .siblings('.menu__item--has-submenu')
          .find('> .menu__link-wrap > .menu__arrow')
          .removeClass('active');

        $submenu.stop(true, true).slideDown(300);
        $arrow.addClass('active');
      }
    });
  });

  $(document).ready(function() {
    $('.menu li.current-menu-ancestor').each(function() {
      const $li = $(this);
      const $submenu = $li.children('ul');
      const $arrow = $li.find('> .menu__link-wrap > .menu__arrow');

      if ($submenu.length) {
        $submenu.show();
        $arrow.addClass('active');
      }
    });
  });

  // Mobile Sticky
  $(document).ready(function() {
    (function() {
      function initMobileHeaderScrolled() {
        var mobileHeader = document.querySelector('.mobile-header');
        if (!mobileHeader) return;

        function toggle() {
          if (window.scrollY > 25) {
            mobileHeader.classList.add('scrolled');
          } else {
            mobileHeader.classList.remove('scrolled');
          }
        }

        toggle();
        window.addEventListener('scroll', toggle, {passive: true});
        window.addEventListener('resize', toggle);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMobileHeaderScrolled);
      } else {
        initMobileHeaderScrolled();
      }
    })();
  });

  // -----------------------------------------------------------------------
  // Hero Section Height with Compatibility Adjustments
  // -----------------------------------------------------------------------
  function adjustHeroHeight() {
    var $hero = $('.hero-section-dynamic-height');
    var viewportHeight = $(window).height();
    var minHeight = 800; // Default min-height for small screens

    // Adjust height dynamically (min-height so taller content can extend the hero)
    if (viewportHeight > 1400) {
      $hero.css('min-height', '1400px'); // Fixed height for very tall screens
    } else if (viewportHeight > minHeight) {
      $hero.css('min-height', viewportHeight + 'px');
    } else {
      $hero.css('min-height', minHeight + 'px');
    }

    // Set custom --vh property for additional compatibility
    const vh = window.innerHeight * 0.01; // 1vh = 1% of viewport height
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  // Run on page load and resize
  adjustHeroHeight();
  $(window).on('resize', adjustHeroHeight);

  // -----------------------------------------------------------------------
  // Driving Results - Accordian (home)
  // -----------------------------------------------------------------------
  jQuery(document).ready(function($) {
    $('.driving-results__accordion-heading').on('click', function(e) {
      e.preventDefault();

      var $accordionItem = $(this).closest('.driving-results__accordion-item');
      var $description = $accordionItem.find('.driving-results__accordion-description');
      var $icon = $(this).find('svg');

      if ($description.hasClass('active')) {
        $description.removeClass('active').css('max-height', '0px');
        $icon.removeClass('rotate');
      } else {
        $('.driving-results__accordion-description')
          .removeClass('active')
          .css('max-height', '0px');
        $('.driving-results__accordion-heading svg').removeClass('rotate');

        var contentHeight = $description.prop('scrollHeight') + 'px';
        $description.addClass('active').css('max-height', contentHeight);
        $icon.addClass('rotate');
      }
    });
  });

  // -----------------------------------------------------------------------
  // Standard - Accordian
  // -----------------------------------------------------------------------
  $('.faq-accordion__question').on('click', function() {
    var $this = $(this);
    var $answer = $this.next('.faq-accordion__answer');
    var $icon = $this.find('.faq-accordion__icon');

    // Close all other accordions
    $('.faq-accordion__answer')
      .not($answer)
      .slideUp(300);
    $('.faq-accordion__icon')
      .not($icon)
      .removeClass('rotate')
      .text('+');

    // Toggle the clicked one
    $answer.slideToggle(300);
    $this.toggleClass('faq-accordion__question--active');

    $icon.toggleClass('rotate');
    $icon.text($icon.hasClass('rotate') ? '-' : '+');
  });

  // -----------------------------------------------------------------------
  // Parallax Hero Section
  // -----------------------------------------------------------------------

  let scrollY = window.scrollY;

  function updateParallax() {
    const img = document.querySelector('.hero-section-bg__image');
    const overlay = document.querySelector('.hero-section__overlay');
    const hero = document.querySelector('.hero-section');

    if (img && overlay && hero) {
      // Parallax effect
      img.style.transform = `translate3d(0, ${scrollY * 0.2}px, 0)`;

      // Darken overlay as you scroll
      let overlayOpacity = scrollY / 800;
      overlayOpacity = Math.min(Math.max(overlayOpacity, 0), 1);
      overlay.style.backgroundColor = `rgba(0, 0, 0, ${overlayOpacity})`;

      // Fade out image after hero scrolls out
      const heroHeight = hero.offsetHeight;
      let imgOpacity = 1 - scrollY / heroHeight;
      imgOpacity = Math.min(Math.max(imgOpacity, 0), 1);
      img.style.opacity = imgOpacity;
    }

    requestAnimationFrame(updateParallax);
  }

  // Track scroll position
  window.addEventListener('scroll', () => {
    scrollY = window.scrollY;
  });

  // Start the animation loop
  updateParallax();

  // About Page - Parallax BGs
  function updateParallaxAboutBGs() {
    const sections = document.querySelectorAll('.about-content__top-section, .about-content__middle-section, .about-content__bottom-section');

    const windowHeight = window.innerHeight;

    sections.forEach((section) => {
      const img = section.querySelector('.parallax-about-bg-img');
      const overlay = section.querySelector('.parallax-about-bg-overlay');

      if (!img || !overlay) return;

      const rect = section.getBoundingClientRect();

      // Only parallax if section is on screen
      if (rect.bottom > 0 && rect.top < windowHeight) {
        const offset = -((windowHeight - rect.top) * 0.6);
        img.style.transform = `translateY(${offset}px)`;

        // Fade overlay as it scrolls
        const visibleRatio = 0 - Math.abs(rect.top) / windowHeight;
        const clamped = Math.min(Math.max(visibleRatio, 0), 1);
        overlay.style.backgroundColor = `rgba(0, 0, 0, ${0 * (1 - clamped)})`;
      }
    });

    requestAnimationFrame(updateParallaxAboutBGs);
  }

  updateParallaxAboutBGs();

  // Fade image transition (images only)
  function initHeroBgFade() {
    document.querySelectorAll('.hero-section').forEach((hero) => {
      const img = hero.querySelector('.hero-section-bg__image');

      if (!img) {
        return;
      }

      const show = () => hero.classList.add('is-bg-loaded');

      if (img.complete) {
        requestAnimationFrame(show);
      } else {
        img.addEventListener('load', show, {once: true});
        img.addEventListener('error', show, {once: true});
      }
    });
  }

  initHeroBgFade();
  jQuery(window).on('load', initHeroBgFade);

  // -----------------------------------------------------------------------
  // Text Scroll Animation
  // -----------------------------------------------------------------------

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll('.text-scroll-animation').forEach((target) => {
    const bg = target.dataset.bgColor;
    const fg = target.dataset.fgColor;

    const text = new SplitType(target, {types: 'words, chars'});

    gsap.fromTo(
      text.chars,
      {color: bg},
      {
        color: fg,
        duration: 0.2,
        stagger: 0.03,
        scrollTrigger: {
          trigger: target,
          start: 'top 70%',
          end: 'top 30%',
          scrub: true,
        },
      }
    );
  });
});

// -----------------------------------------------------------------------
// Smooth Scroll Without # Hash in URL
// -----------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {
  const scrollLinks = document.querySelectorAll('.js-scroll-no-hash');

  scrollLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetSelector = this.getAttribute('data-target');
      if (targetSelector) {
        const target = document.querySelector(targetSelector);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
          });
        }
      }
    });
  });
});
